import { Button } from "@blueprintjs/core";
import { DateInput, IDateFormatProps } from "@blueprintjs/datetime";
import React, { useContext, useEffect, useState } from "react";
import PlayerAttendanceElement from "../../components/elements/PlayerAttendance.Element";
import { DB_REF } from "../../constants/DB";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { Player } from "../../interfaces/Player.Interface";
import { dateToFirestore } from "../../services/DateToFirestore";

export default function AttendanceComponent() {
  const [players, setPlayers] = useState<Player[]>([]);
  const firebase = useContext(firebaseContext);
  const [date, setDate] = useState(new Date());
  const [practiceRecord, setPracticeRecord] = useState(false);
  const [loading, setLoading] = useState(true);

  const jsDateFormatter: IDateFormatProps = {
    // note that the native implementation of Date functions differs between browsers
    formatDate: (date) => date.toLocaleDateString(),
    parseDate: (str) => new Date(str),
    placeholder: "M/D/YYYY",
  };

  const checkHasPractice = async () => {
    setLoading(true);
    const col = await firebase
      .firestore()
      .collection(DB_REF.practices)
      .where("date", "==", dateToFirestore(date))
      .get();

    if (col.empty) {
      setPracticeRecord(false);
    } else {
      setPracticeRecord(true);
    }
    setLoading(false);
  };

  const onChange = async (date: Date) => {
    setDate(date);
    checkHasPractice();
  };

  const onClickAddPractice = async () => {
    const addPracticeDay = firebase.functions().httpsCallable("addPracticeDay");
    try {
      const data = await addPracticeDay({
        date: dateToFirestore(date),
      });
      console.log(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    checkHasPractice();
  }, [date]);

  useEffect(() => {
    const getPlayers = () => {
      firebase
        .firestore()
        .collection(DB_REF.players)
        .where("active", "==", true)
        .onSnapshot((col) => {
          setPlayers([]);
          col.forEach((ele) => {
            const data: any = ele.data();
            setPlayers((prev) => [...prev, data]);
          });
        });
    };

    firebase
      .firestore()
      .collection(DB_REF.practices)
      .where("date", "==", dateToFirestore(date))
      .onSnapshot((col) => {
        if (!col.empty) {
          getPlayers();
        } else {
          setPlayers([]);
        }
      });
  }, [firebase, date]);

  const renderPlayerElements = () => {
    return players.map((ele, index) => {
      return (
        <div key={index}>
          {<PlayerAttendanceElement date={date} player={ele} />}
        </div>
      );
    });
  };

  return (
    <div>
      <div
        style={{
          alignItems: "center",
          display: "flex",
          padding: 40,
          flexDirection: "column",
        }}
      >
        <div style={{ padding: 10 }}>Create a practice day</div>
        <div style={{ padding: 10 }}>
          <DateInput {...jsDateFormatter} value={date} onChange={onChange} />
        </div>
        {!loading && !practiceRecord && (
          <div style={{ padding: 10 }}>
            <Button
              text="Set as a practice date"
              onClick={onClickAddPractice}
              intent="primary"
            />
          </div>
        )}
      </div>
      <div>{renderPlayerElements()}</div>
    </div>
  );
}
